import { render, staticRenderFns } from "./VideoResult.vue?vue&type=template&id=a21675c6&scoped=true&"
import script from "./VideoResult.vue?vue&type=script&lang=js&"
export * from "./VideoResult.vue?vue&type=script&lang=js&"
import style0 from "./VideoResult.vue?vue&type=style&index=0&id=a21675c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21675c6",
  null
  
)

export default component.exports